/** Tab ids, URL paths, and short titles (browser tab + GA page_title). */

export const TOOL_ROUTES = [
  { id: 'home', path: '/', title: 'Home' },
  { id: 'invisible-character-legend', path: '/invisible-character-legend', title: 'Invisible Character Legend' },
  { id: 'invisible-characters', path: '/invisible-characters', title: 'Invisible Characters' },
  { id: 'eml-msg-analyzer', path: '/eml-msg-analyzer', title: 'EML Analyzer' },
  { id: 'url-safety-checker', path: '/url-safety-checker', title: 'URL Safety' },
  { id: 'safe-links-decoder', path: '/safe-links-decoder', title: 'Safe Links Decoder' },
  { id: 'mail-header-analyzer', path: '/mail-header-analyzer', title: 'Mail Header' },
] as const;

export type ToolTabId = (typeof TOOL_ROUTES)[number]['id'];

export const PATH_TO_TAB_ID: Record<string, ToolTabId> = Object.fromEntries(
  TOOL_ROUTES.map((r) => [r.path, r.id]),
) as Record<string, ToolTabId>;

export const TAB_ID_TO_PATH: Record<ToolTabId, string> = Object.fromEntries(
  TOOL_ROUTES.map((r) => [r.id, r.path]),
) as Record<ToolTabId, string>;

export const TAB_ID_TO_PAGE_TITLE: Record<ToolTabId, string> = Object.fromEntries(
  TOOL_ROUTES.map((r) => [r.id, r.title]),
) as Record<ToolTabId, string>;

export function normalizePathname(pathname: string): string {
  if (!pathname || pathname === '/') {
    return '/';
  }
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}

export function tabIdFromPathname(pathname: string): ToolTabId | undefined {
  return PATH_TO_TAB_ID[normalizePathname(pathname)];
}

export function pathForTabId(tabId: string): string {
  if (tabId in TAB_ID_TO_PATH) {
    return TAB_ID_TO_PATH[tabId as ToolTabId];
  }
  return '/';
}
